<section
    class=" content2-bg-image no-padding cover-background xs-bg-none border-none bg-img-ten header-margin-top-medium"
    id="" data-img-size="(W)1920px X (H)590px"
    style="background: linear-gradient(rgba(0, 0, 0, 0.00784314), rgba(0, 0, 0, 0.00784314)), url('assets/images/bg-image/bg-home-empresa.jpg') fixed;">
    <div class="container sm-width-100 sm-no-padding">
        <div
            class="bg-cream  width-80 sm-width-60 xs-width-100 content-style1 padding-four md-padding-eight sm-padding-eighteen">
            <!-- section title -->
            <h2 *ngIf="esRegistro"
                class="title alt-font title-extra-large-2 sm-title-extra-large-2 xs-section-title-large text-brown margin-one-bottom">
                Registrarse</h2>
            <h2 *ngIf="!esRegistro"
                class="title alt-font title-extra-large-2 sm-title-extra-large-2 xs-section-title-large text-brown margin-one-bottom">
                Mi Cuenta</h2>
            <form [formGroup]="registroForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <label for="nombre">Nombre</label>
                    <input type="text" formControlName="nombre" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.nombre.errors }" />
                    <div *ngIf="submitted && f.nombre.errors" class="invalid-feedback">
                        <div *ngIf="f.nombre.errors.required">First Name is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="apellido">Apellido</label>
                    <input type="text" formControlName="apellido" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.apellido.errors }" />
                    <div *ngIf="submitted && f.apellido.errors" class="invalid-feedback">
                        <div *ngIf="f.apellido.errors.required">Last Name is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="username">Usuario</label>
                    <input type="text" formControlName="username" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.username.errors }" [readonly]="!esRegistro" />
                    <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                        <div *ngIf="f.username.errors.required">Usuario is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="email">Email</label>
                    <input type="text" formControlName="email" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                    <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                        <div *ngIf="f.email.errors.required">Email is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="celular">Celular</label>
                    <input type="text" formControlName="celular" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.celular.errors }" />
                    <div *ngIf="submitted && f.celular.errors" class="invalid-feedback">
                        <div *ngIf="f.celular.errors.required">Celular is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="numero_documento">CI/RUC</label>
                    <input type="text" formControlName="numero_documento" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.numero_documento.errors }" />
                    <div *ngIf="submitted && f.numero_documento.errors" class="invalid-feedback">
                        <div *ngIf="f.numero_documento.errors.required">CI/RUC is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="password">Contraseña</label>
                    <input type="password" formControlName="password" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required">Contraseña is required</div>
                        <div *ngIf="f.password.errors.minlength">Contraseña must be at least 6 characters</div>
                    </div>
                </div>
                <div class="form-group" *ngIf="!esRegistro">
                    <label for="newPassword">Nueva contraseña</label>
                    <input type="password" formControlName="newPassword" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.newPassword.errors }" />
                    <div *ngIf="submitted && f.newPassword.errors" class="invalid-feedback">
                        <div *ngIf="f.newPassword.errors.required">Contraseña is required</div>
                        <div *ngIf="f.newPassword.errors.minlength">Contraseña must be at least 6 characters</div>
                        <div *ngIf="f.newPassword.errors.mismatch">Las contraseñas son distintas</div>
                    </div>
                </div>
                <div class="form-group" *ngIf="!esRegistro">
                    <label for="confirmPassword">Confirmar contraseña</label>
                    <input type="password" formControlName="confirmPassword" class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />
                    <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                        <div *ngIf="f.confirmPassword.errors.required">Contraseña is required</div>
                        <div *ngIf="f.confirmPassword.errors.minlength">Contraseña must be at least 6 characters</div>
                        <div *ngIf="f.confirmPassword.errors.mismatch">Las contraseñas son distintas</div>
                    </div>
                </div>
                <div class="form-group" *ngIf="!esRegistro">
                    <input type="checkbox" name="notificar_sms" style="width:12px; height:12px;"
                        formControlName="notificar_sms"> Deseo Recibir Notificaciones via SMS <br>
                    <input type="checkbox" name="notificar_email" style="width:12px; height:12px;"
                        formControlName="notificar_email"> Deseo Recibir Notificaciones via Email <br>
                    <input type="checkbox" name="notificar_dispositivo" style="width:12px; height:12px;"
                        formControlName="notificar_dispositivo"> Deseo Recibir Notificaciones en dispositivo </div>
                <div *ngIf="esRegistro">
                    <botdetect-captcha styleName="ExampleCaptcha"></botdetect-captcha>
                    <label>
                        <span>Escribí las letras de la imagen de arriba:</span>
                        <input type="text" id="captchaCode" name="captchaCode" formControlName="captchaCode">
                    </label>
                </div>
                <div class="form-group" *ngIf="esRegistro">
                    <div class="checkbox-inline">
                        <input class="checkbox" type="checkbox" value="" style="width:12px; height:12px;"
                            formControlName="aceptado" (ngModelChange)="onAceptadoChange($event)">
                        <label>Declaro haber leído y aceptado las condiciones de subasta de Tropeando S.A.</label>
                        <div>Leé acá las <a (click)="lgModal.show()"
                                class="btn-small btn-circle btn bg-dark-brown text-white"> Condiciones de Subasta. </a>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <button *ngIf="esRegistro" [disabled]="!aceptado || loading"
                        class="btn-medium btn-circle btn bg-dark-brown text-white">Registrarse</button>
                    <button *ngIf="!esRegistro" [disabled]="loading"
                        class="btn-medium btn-circle btn bg-dark-brown text-white">Guardar cambios</button> &nbsp; <img
                        *ngIf="loading"
                        src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    <a *ngIf="esRegistro" [routerLink]="['/login']"
                        class="btn-medium btn-circle btn bg-dark-brown text-white">Cancelar</a>
                </div>
                <alert *ngIf="alerta!=''" type="danger" [dismissible]="true" (onClosed)="onClosed(alert)">{{ alerta }}
                </alert>
            </form>
            <div *ngIf="!esRegistro" class="panel panel-default">
                <div class="panel-heading">
                    <h3 class="panel-title">Dispositivos subscriptos a notificaciones</h3>
                </div>
                <ul class="list-group">
                    <li class="list-group-item" *ngFor="let dispositivo of suscripciones"> Dispositivo:
                        {{dispositivo.dispositivo}} Aplicación: {{dispositivo.aplicacion}} Fecha creación:
                        {{dispositivo.creacion | date:'dd/MM/yyyy h:mm:ss'}} <span
                            (click)="eliminarDispositivo(dispositivo.id)" class="glyphicon glyphicon-remove-circle"
                            aria-hidden="true"></span>
                    </li>
                </ul>
            </div>
            <div bsModal #lgModal="bs-modal" class="modal fade" tabindex="-1" role="dialog"
                aria-labelledby="dialog-sizes-name1">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close pull-right" aria-label="Close" (click)="lgModal.hide()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <app-condiciones-subasta></app-condiciones-subasta>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
